import { registerModal } from 'features/Modal/ModalRegistry'
import { AnalyticsShareModalContainer } from './AnalyticsShareModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'ANALYTICS_SHARE'
registerModal(modalType, AnalyticsShareModalContainer)

export interface IShowAnalyticsShareModalProps {
  serviceId: string
}

export const showAnalyticsShareModal = (modalProps: IShowAnalyticsShareModalProps) =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {},
  })



// WEBPACK FOOTER //
// src/features/CallAnalytics/AnalyticsShareModal/AnalyticsShareModal.action.ts